import { render, staticRenderFns } from "./BaseDocumentationCard.vue?vue&type=template&id=e04c2eb2&scoped=true&"
import script from "./BaseDocumentationCard.vue?vue&type=script&lang=js&"
export * from "./BaseDocumentationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04c2eb2",
  null
  
)

export default component.exports